import type { StarVariantProps } from "./star-variants";

import { cn } from "@homeinstead/ui";
import StarSVG from "./star.svg";
import { starVariants } from "./star-variants";

export interface StarProps extends StarVariantProps {
  className?: string;
}

const Star = ({ className, variant }: StarProps) => (
  <StarSVG
    aria-label={`Star ${variant}`}
    className={cn(starVariants({ variant }), className)}
  />
);

export default Star;
